import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginatePlantActions } from "store/ducks/settings/plant";

export function* paginatePlantRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/plants?${queryString}`
    );

    const { types, pagination } = responseBody;
    yield put(PaginatePlantActions.success(types, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginatePlantActions.failure(errorMessage));
  }
}
